import {useRef} from 'react'

import {ExposeFolderCtaEnum} from '@sdox/api'
import {Button, CarSummary, Checkbox, Dialog, TextLink} from '@sdox/ui'
import {noop} from '@sdox/utils'

import type {CtaCallbackDataInput, XcRecord_XcSeDataType_Fragment} from '@sdox/api'

export interface CallbackProps {
  title: string
  placeholder: string
  onSubmit: (value: CtaCallbackDataInput) => void
  loading: boolean
  error?: string | null
  record: XcRecord_XcSeDataType_Fragment
  onOpenPrivacyDialog?(): void
  isEmailRequired?: boolean
  submitLabel?: string
}

// @deprecated
export const Callback = ({
  onSubmit,
  loading,
  placeholder,
  record,
  title,
  error = '',
  isEmailRequired = true,
  onOpenPrivacyDialog = noop,
  submitLabel = 'Anfrage absenden',
  ...restProps
}: CallbackProps) => {
  const formRef = useRef<HTMLFormElement | null>(null)

  return (
    <Dialog.Content {...restProps}>
      <Dialog.Section>
        <CarSummary
          className={'mb-8'}
          title={title}
          subline={record?.expose.interneNummer || undefined}
          image={record?.expose.keyVisual?.thumbnailUrl ?? null}
          available={!!record?.expose.archived}
          reserved={!!record?.expose.reserviert}
        />
        <form
          ref={formRef}
          autoComplete={'on'}
          onSubmit={(e) => {
            e.preventDefault()
            if (!formRef.current) return
            const formData = new FormData(formRef.current)
            const actions: ExposeFolderCtaEnum[] = []

            for (const type of [
              ExposeFolderCtaEnum.TestDrive,
              ExposeFolderCtaEnum.ConsultingSpeech,
              ExposeFolderCtaEnum.Buy,
            ]) {
              if (formData.get(type)) {
                actions.push(type)
              }
              formData.delete(type)
            }

            const formProps = Object.fromEntries(formData) as unknown as CtaCallbackDataInput

            formProps.actions = actions

            onSubmit(formProps)
          }}
        >
          <div className={'my-6 flex flex-col gap-4 sm:flex-row sm:flex-wrap sm:items-center'}>
            <Checkbox
              label={'Probefahrt'}
              name={ExposeFolderCtaEnum.TestDrive}
            />
            <Checkbox
              label={'Beratung'}
              name={ExposeFolderCtaEnum.ConsultingSpeech}
            />
            <Checkbox
              label={'Kaufanfrage'}
              name={ExposeFolderCtaEnum.Buy}
            />
          </div>
          <div className={'mb-2 flex flex-wrap gap-2'}>
            <select
              // eslint-disable-next-line tailwindcss/no-custom-classname
              className={'input-simple mb-0 w-full sm:w-1/3'}
              name={'salutation'}
              defaultValue={''}
            >
              <option
                value={''}
                disabled
              >
                Anrede
              </option>
              <option value={'Herr'}>Herr</option>
              <option value={'Frau'}>Frau</option>
              <option value={'Divers'}>Divers</option>
            </select>
            <input
              type={'text'}
              placeholder={'Vor- und Nachname'}
              // eslint-disable-next-line tailwindcss/no-custom-classname
              className={'input-simple mb-0 flex-1 sm:w-full'}
              required
              name={'name'}
            />
          </div>
          <input
            type={'tel'}
            placeholder={'Telefonnummer'}
            // eslint-disable-next-line tailwindcss/no-custom-classname
            className={'input-simple mb-2 w-full'}
            required
            name={'phone'}
          />
          <input
            type={'email'}
            placeholder={'E-Mail-Adresse'}
            // eslint-disable-next-line tailwindcss/no-custom-classname
            className={'input-simple mb-2 w-full'}
            required={isEmailRequired}
            name={'email'}
          />
          <textarea
            // eslint-disable-next-line tailwindcss/no-custom-classname
            className={'input-simple w-full'}
            rows={4}
            defaultValue={placeholder}
            name={'text'}
          />
          <p className={' text-sm text-gray-500'}>
            Informationen zum Umgang mit Ihren personenbezogenen Daten finden Sie in unseren{' '}
            <TextLink
              onClick={(e) => {
                e.preventDefault()
                onOpenPrivacyDialog()
              }}
            >Datenschutzhinweisen
            </TextLink>.
          </p>
          <div className={'my-4 sm:mt-8'}>
            {error !== '' && <div>{error}</div>}
            <Button
              className={'w-full'}
              type={'submit'}
              variant={'filled-brand'}
              loading={loading}
              disabled={loading}
              mboAttrs={{piece: 'Anfrage absenden', prefix: 'CallbackDialog'}}
            >
              {submitLabel}
            </Button>
          </div>
        </form>
      </Dialog.Section>
    </Dialog.Content>
  )
}
